// Page
import Login from "../components/Registration/Login/index.js";

const LoginPage = () => {
	return (
		<Login/>
	)
}

export default LoginPage;